var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.setting.width},on:{"click:outside":_vm.close},model:{value:(_vm.setting.is_show),callback:function ($$v) {_vm.$set(_vm.setting, "is_show", $$v)},expression:"setting.is_show"}},[_c('v-card',{style:({
            position: 'relative'
        })},[_c('span',{style:({
                display: 'block',
                width: '30px',
                height: '30px',
                lineHeight: '30px',
                position: 'absolute',
                top: '15px',
                right: '15px',
                cursor: 'pointer'
            }),on:{"click":_vm.close}},[_c('v-icon',[_vm._v(" mdi-close ")])],1),_vm._t("card-title",function(){return [_c('v-card-title',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.setting.title)+" ")])]}),(_vm.setting.subtitle)?_c('v-card-subtitle',{staticClass:"card-subtitle"},[_vm._v(_vm._s(_vm.setting.subtitle))]):_vm._e(),(_vm.setting.description)?_c('v-card-subtitle',{staticClass:"card-subtitle",style:({
            })},[_vm._v(_vm._s(_vm.setting.description))]):_vm._e(),_c('div',{style:({
            position: 'relative',
            overflowX: 'auto',
            maxWidth: '800px'
          })},[_c('v-textarea',{ref:"body_script",style:({
              padding: '0px 24px 0px',
              borderColor: '#dadce0',
              borderRadius: '4px',
              height: 'auto',
              margin: '0',
              minHeight: '50px',
              verticalAlign: 'top',
              fontFamily: 'courier new,courier,monospace',
              fontSize: '12px',
              maxWidth: '800px',
              overflow: 'auto'
            }),attrs:{"value":`${_vm.setting.html_code}`,"no-resize":"","readonly":"","outlined":"","name":"input-7-4","color":this.$vuetify.theme.themes['dark']['primary']}}),_c('button',{style:({
              position: 'absolute',
              top: '15px',
              right: '40px',
              cursor: 'pointer',
            }),on:{"click":_vm.copyContent}},[_c('v-icon',[_vm._v(" mdi-clipboard-multiple-outline ")])],1)],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }